(function ($) {
  (function preventAnchorScroll() {
    if ($('.leadership-grid').length) {
      var scrollToTop = function () {
        $(window).scrollTop(0);
      };
      if (window.location.hash) {
        // handler is executed at most once
        $(window).one('scroll', scrollToTop);
      }

      // make sure to release scroll 1 second after document readiness
      // to avoid negative UX
      $(function () {
        setTimeout(function () {
          $(window).off('scroll', scrollToTop);
        }, 1000);
      });
    }
  })();

  $(function () {
    var $leadershipGrid = $('.leadership-grid');

    if ($leadershipGrid.length) {
      var leadershipGrid = (function() {
        var $leadershipGridWrapper = $leadershipGrid.find('.leadership-grid__wrapper');
        var $leadershipCardColumn = $leadershipGridWrapper.find('.row > div');
        var $leadershipCard = $leadershipGrid.find('.leadership-card');
        var leadershipCardBreakpoints = getLeadershipCardBreakpoints();
        var prevOverlayPos = null;

        function createAccordionHtml(content) {
          return `<div class="col-12 accordion-content mt-md">
                <div class="leadership-content bg-dark-blue text-white">
                  <div class="pattern__wrapper">
                    <div class="pattern pattern--bg pattern--green-blob"></div>
                  </div>
                  <span class="close-button close-button--white"></span>
                  <div class="leadership-content__wrapper">
                    ${content}
                  </div>
                </div>
              </div>`;
        }

        function getContent(element) {
          return $(element).find('.leadership-card__blurb').html();
        }

        function getLeadershipCardBreakpoints() {
          var breakpoints = {}; 
          
          $leadershipCardColumn.attr('class').split(' ').forEach(function (className) {
            var breakpoint = className.replace(new RegExp("\\b" + 'col-' + "\\b", "gi"), "").split('-')[0];
            var columns = parseInt(className.replace(new RegExp("\\b" + 'col-' + "\\b", "gi"), "").split('-')[1], 10);

            if (isNaN(columns)) {
              columns = parseInt(breakpoint);
              breakpoint = 'xs';
            }

            breakpoints[breakpoint] = columns;
          });
          
          return breakpoints;
        }

        function getCardsPerColumn() {
          var cardsPerColumn;

          if ($(window).width() >= 1280) {
            if (leadershipCardBreakpoints.hasOwnProperty('xl')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.xl;
            } else if (leadershipCardBreakpoints.hasOwnProperty('lg')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.lg;
            } else if (leadershipCardBreakpoints.hasOwnProperty('md')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.md;
            } else if (leadershipCardBreakpoints.hasOwnProperty('sm')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.sm;
            } else if (leadershipCardBreakpoints.hasOwnProperty('xs')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.xs;
            }
          } else if ($(window).width() >= 992 & $(window).width() < 1280) {
            if (leadershipCardBreakpoints.hasOwnProperty('lg')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.lg;
            } else if (leadershipCardBreakpoints.hasOwnProperty('md')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.md;
            } else if (leadershipCardBreakpoints.hasOwnProperty('sm')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.sm;
            } else if (leadershipCardBreakpoints.hasOwnProperty('xs')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.xs;
            }
          } else if ($(window).width() >= 768 & $(window).width() < 992) {
            if (leadershipCardBreakpoints.hasOwnProperty('md')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.md;
            } else if (leadershipCardBreakpoints.hasOwnProperty('sm')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.sm;
            } else if (leadershipCardBreakpoints.hasOwnProperty('xs')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.xs;
            }
          } else if ($(window).width() >= 576 & $(window).width() < 768) {
            if (leadershipCardBreakpoints.hasOwnProperty('sm')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.sm;
            } else if (leadershipCardBreakpoints.hasOwnProperty('xs')) {
              cardsPerColumn = 12 / leadershipCardBreakpoints.xs;
            }
          } else {
            cardsPerColumn = 12 / leadershipCardBreakpoints.xs;
          }

          return cardsPerColumn;
        }

        function addCardNumbers() {
          $leadershipCard.each(function(index) {
            var cardNumber = (index + 1);
            $(this).attr('data-id', cardNumber);
          });
        }

        function getOverlayPosition(activeCard) {
          var $activeCard = $(activeCard);
          var cardNumber = $activeCard.attr('data-id');
          var totalCards = $leadershipCard.length;

          var elementPosition =
            Math.ceil(cardNumber / getCardsPerColumn()) * getCardsPerColumn() -
              1 <
            totalCards
              ? Math.ceil(cardNumber / getCardsPerColumn()) *
                  getCardsPerColumn() -
                1
              : totalCards - 1;

          return elementPosition;
        }

        function getMainNavHeight() {
          return $('header').find('.main-nav').outerHeight();
        }

        function getAnchorOffsetTop(anchor) {
          var $anchor = $(anchor);

          if ($anchor.length) {
            return $anchor.offset().top;
          }
        }

        function smoothScrollTo(el) {
          var currentScrollPos = $(window).scrollTop();
          var anchorOffsetTop = getAnchorOffsetTop(el);
          var scrollTopPos;

          if (currentScrollPos < anchorOffsetTop) {
            if ($(window).width() > 1023) {
              scrollTopPos = anchorOffsetTop - getMainNavHeight() + 1;
            } else {
              scrollTopPos = anchorOffsetTop - getMainNavHeight() + 1;
            }
          } else {
            scrollTopPos = anchorOffsetTop - getMainNavHeight() + 1;
          }

          $('html, body').animate(
            {
              scrollTop: scrollTopPos
            },
            700
          );
        }

        function smoothScrollOnHash() {
          smoothScrollTo(window.location.hash);
        }

        function displayOverlay(activeCard) {
          var $activeCard = $(activeCard);
          var overlayPos = getOverlayPosition($activeCard);

          if ($(window).width() >= 786 && prevOverlayPos == overlayPos && $('.accordion-content').length) {
            $leadershipGrid.removeAttr('style');
            $('.leadership-content__wrapper').html(getContent($activeCard));
          } else {
            $('.accordion-content').remove();
            $leadershipCardColumn.eq(overlayPos).after(createAccordionHtml(getContent($activeCard)));
           
            $('.accordion-content').slideDown(400).promise().always(function(){
              smoothScrollTo('.leadership-content');
            });
          }

          if ($(window).width() < 768) { 
            $leadershipGrid.css('z-index', $('header').css('z-index'));
          }

          prevOverlayPos = overlayPos;
        }
        
        function resetOverlayPositionOnResize() {
          if ($('.accordion-content').length) {
            var $activeCard = $('.leadership-card--active');
            var overlayPos = getOverlayPosition($activeCard);
            var accordionHtml = createAccordionHtml(getContent($activeCard));

            $('.accordion-content').remove();
            $leadershipCardColumn.eq(overlayPos).after(accordionHtml);

            if ($(window).width() >= 768) {
              $leadershipGrid.removeAttr('style');
            } else {
              $leadershipGrid.css('z-index', $('header').css('z-index'));
            }

            $('.accordion-content').show();

            prevOverlayPos = overlayPos;
          }
        }

        function handleLeadershipCardClick() {
          var $thisCard = $(this);

          if ($thisCard.hasClass('leadership-card--active')) {
            return false;
          }

          $leadershipCard.removeClass('leadership-card--active');
          $thisCard.addClass('leadership-card--active');

          displayOverlay($thisCard);
        }

        function handleLeadershipAccordionCloseClick() {  
          $('.leadership-card--active').removeClass('leadership-card--active');

          if ($(window).width() < 768) { 
            $leadershipGrid.removeAttr('style');
          }

          $('.accordion-content').slideUp(function () {
            $('.accordion-content').remove();
          });
        }

        return {
          init: function () {
            addCardNumbers();
            this.bindEvents();
          },
          load: function () {
            smoothScrollOnHash();
          },
          resize: function () {
            resetOverlayPositionOnResize();
          },
          bindEvents: function () {
            $leadershipGridWrapper.on('click', '.leadership-card', handleLeadershipCardClick);
            $leadershipGrid.on('click', '.leadership-content .close-button', handleLeadershipAccordionCloseClick);
          }
        }
      })();

      leadershipGrid.init();
      $(window).on('load', leadershipGrid.load);
      $(window).on('resize', leadershipGrid.resize);
    }
  });
})(jQuery);
